import { render } from "./CompetitionSubmissionForm.html?vue&type=template&id=8b4e0e3a&scoped=true&external"
import script from "./CompetitionSubmissionForm.js?vue&type=script&lang=js&external"
export * from "./CompetitionSubmissionForm.js?vue&type=script&lang=js&external"

import "./CompetitionSubmissionForm.css?vue&type=style&index=0&id=8b4e0e3a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4e0e3a"]])

export default __exports__